window.AltTextWidget = {
    upload: function (file) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('image', file);

            fetch('https://api-staging.neosidekick.com/api/v1/image-alt-text?language=de', {
                method: 'POST',
                body: formData,
                headers: {
                    accept: 'application/json',
                },
            })
                .then((response) => {
                    if (response.status !== 200) {
                        return response.json().then((data) => Promise.reject(data));
                    }
                    return response.json();
                })
                .then((data) => resolve(data))
                .catch((error) => reject(error));
        });
    },
};
